// Source of truth: https://zeroheight.com/027fa224e/p/424a0a-colors

// Primary colors

export const green = "#58655B";
export const greenDarkest = "#2C332D";
export const greenDarker = "#434D45";
export const greenLighter = "#6F7F72";
export const greenLightest = "#85998A";

export const lightBlue = "#E1E4EE";
export const lightBlueDarkest = "#808187";
export const lightBlueDarker = "#989AA1";
export const lightBlueDark = "#C8CBD4";
export const lightBlueLighter = "#E6E9F4";
export const lightBlueLightest = "#F1F4FF";

export const violet = "#D0C8FB";
export const violetDarkest = "#7B7794";
export const violetDarker = "#9F9AC0";
export const violetDark = "#BAB3E0";
export const violetLighter = "#E6E2FB";
export const violetLightest = "#F0EEFB";
export const violetDeep = "#927CFF";

export const lightGray = "#F6F4F2";
export const lightGrayDarkest = "#8E8D8D";
export const lightGrayDarker = "#A8A7A6";
export const lightGrayDark = "#C2C1BF";
export const lightGrayLighter = "#DBDAD8";
export const lightGrayLightest = "#FAF8F6";

export const olive = "#BFBDA9";
export const oliveDarkest = "#737266";
export const oliveDarker = "#8C8B7C";
export const oliveDark = "#A6A493";
export const oliveLighter = "#D9D6C0";
export const oliveLightest = "#F2F0D6";

export const yellow = "#F0FF71";
export const yellowDarkest = "#909944";
export const yellowDarker = "#A8B24F";
export const yellowDark = "#C0CC5A";
export const yellowLighter = "#D8E566";
export const yellowLightest = "#F9FFCC";

export const black = "#1D1D1F";
export const blackLight = "#333333";
export const blackLightest = "#666666";

export const white = "#FFFFFF";
export const whiteDark = "#E6E6E6";
export const whiteDarker = "#CCCCCC";
export const whiteDarker2 = "#B3B3B3";
export const whiteDarkest = "#999999";

// Warm off-white surfaces used by the creatives-portal shell (Figma-driven)
export const offWhite = "#FCFCFB";
export const cream = "#F0EEEA";
export const creamDark = "#E7E5E0";

// Accent colors (Figma component library)
export const blueSoft = "#EAF0FB";
export const blueDeep = "#1E6DD6";

// Status colors

export const successDark = "#26B941";
export const successMedium = "#63E764";
export const successLight = "#BCFBAE";
export const successBackground = "rgba(38, 185, 65, 0.2)";
export const successText = black;

export const warningDark = "#E17655";
export const warningMedium = "#F09E78";
export const warningLight = "#FFA77F";
export const warningBackground = "rgba(255, 167, 127, 0.2)";
export const warningText = black;

export const errorDark = "#FF0000";
export const errorMedium = "#F47979";
export const errorLight = "#FFB1B1";
export const errorBackground = "rgba(255, 0, 0, 0.2)";
export const errorBackgroundSubtle = "rgba(255, 0, 0, 0.08)";
export const errorBackgroundLight = "rgba(255, 0, 0, 0.12)";
export const errorText = black;

export const infoBackground = blackLight;
export const infoText = white;

// Ranges by signatures chart colors

// Colors, taken from Remerge palette
export const RangesBySignaturesChartBaseColors = [
  "#D2C8FF",
  // "#E0E4EF", // <- very pale and close to lightGray for production flight
  "#54665A",
  "#EEFF53",
  "#0EB76C",
  "#BFBDA7",
  "#F47979",
];
// +30% saturation to widen the options for extra large charts.
// Each item corresponds to one above, but with 30% saturation applied
export const RangesBySignaturesChartSaturatedColors = [
  "#927CFF",
  "#97AFED",
  "#40664C",
  // "#EAFF07", // <- eye-wateringly bright
  // no +30% saturation for #0eb76c, it's already at 92%
  "#BCB66D",
  "#F23030",
];

// Semantic aliases

export const lightGrayBorder = lightGrayLighter;
export const grayBorder = whiteDarker;

export const grayBackground = "#FAFAFA";
export const lightBackground = lightGrayLightest;
export const darkBackground = blackLightest;

export const grayFont = lightGrayDarkest;
export const lightGrayFont = whiteDarker2;
export const lightOutlineGray = whiteDark;

export const disabledGrayBackground = lightGrayLightest;
export const disabledGray = lightGrayLighter;
